import React						from 'react';

import {ChildrenElement}			from '../../typescript-declaration/global';

import MultiInputContainer			from '../Input/MultiInputContainer';

import './Button.css';


interface Props {
	children: ChildrenElement,
	noFlex?: boolean
}

function ButtonStickyContainer(props: Props) {
	return (
		<>
			{!props.noFlex ?
				<div className={'flex'} />
				:
				<br />
			}
			<div className={'buttonStickyContainer'}>
				<MultiInputContainer>
					{props.children}
				</MultiInputContainer>
			</div>
		</>
	);
}

export default ButtonStickyContainer;